// src/components/Sidebar.jsx
import {
  ClipboardList, Calendar, Settings, Monitor,
  Play, Menu, User, ChevronLeft,
} from "lucide-react";
import "../styles/Sidebar.css";
import { useNavigate } from "react-router-dom";

const navItems = [
  { id: 0, icon: ClipboardList, label: "Study list", path: "/patient" },
  { id: 3, icon: Monitor, label: "Manage template", path: "/report-format" },
  // { id: 0, icon: ClipboardList, label: "Study list" },
  // { id: 1, icon: Calendar,      label: "Report summary" },
  // { id: 2, icon: Settings,      label: "Manage preference" },
  // { id: 3, icon: Monitor,       label: "Manage template" },
];
const bottomItems = [
  { id: 4, icon: null,  label: "Application", isLogo: true },
  { id: 5, icon: Play,  label: "Support Videos" },
  { id: 6, icon: Menu,  label: "Keyboard Shortcut" },
  { id: 7, icon: User,  label: "Voice support" },
];

function ApplicationIcon({ size = 20 }) {
  return (
    <div
      className="sidebar-app-icon"
      style={{ width: size + 4, height: size + 4 }}
    >
      <svg
        width={size - 4}
        height={size - 4}
        viewBox="0 0 24 24"
        fill="none"
        stroke="rgba(255,255,255,0.85)"
        strokeWidth="2.2"
        strokeLinecap="round"
      >
        <circle cx="12" cy="12" r="4" />
        <path d="M12 2v3M12 19v3M2 12h3M19 12h3" />
      </svg>
    </div>
  );
}
export default function Sidebar({ isOpen, onClose, onOpen, activeToolId, onToolSelect }) {
  const navigate = useNavigate();
  const renderItem = (item) => {
    const Icon     = item.icon;
    const isActive = activeToolId === item.id;
    return (
      <div
        key={item.id}
        title={!isOpen ? item.label : undefined}
        onClick={() => {
          onToolSelect(item.id);
          navigate(item.path);
      }}
        className={[
          "sidebar-item",
          isOpen   ? "expanded"  : "collapsed",
          isActive ? "active"    : "",
        ].join(" ")}
      >
        {item.isLogo
          ? <ApplicationIcon size={20} />
          : <Icon size={isOpen ? 18 : 20} style={{ flexShrink: 0 }} />
        }
        {isOpen && <span>{item.label}</span>}
      </div>
    );
  };
  return (
    <div
      className="sidebar"
      style={{ width: isOpen ? 210 : 50 }}
    >
      {isOpen && (
        <div className="sidebar-toggle-row expanded">
          <button className="sidebar-toggle-btn" onClick={onClose} >
            <ChevronLeft size={14} />
          </button>
        </div>
      )}
      {/* Top nav items */}
      <div className="sidebar-nav-top">
        {navItems.map(renderItem)}
      </div>
      {/* Spacer */}
      <div className="sidebar-spacer" />
      {/* Bottom items */}
      {/* <div className="sidebar-nav-bottom">
        {isOpen && (
          <span className="sidebar-copyright">© 2026</span>
        )}
        {bottomItems.map(renderItem)}
      </div> */}
    </div>
  );
}